import { ComponentType, FC, useMemo } from "react";
import { KnownHostnames } from "../../types/Defaults";

type HistoricalPortfolioProps = {
  authToken: string;
  productId?: number;
  type?: "PRODUCT" | "COMBINED";
  userType?: string;
};

export type IframeHOCProps = {
  domain: string;
};

export const withIframeDomain: <P>(
  Component: ComponentType<P & IframeHOCProps>
) => FC<P> = (Component) => {
  return (props) => {
    const domain = useMemo(() => {
      const hostname: KnownHostnames = window.document.location
        .hostname as KnownHostnames;

      switch (hostname) {
        case "localhost":
          return "http://localhost:3000"; // For local development, point to the local backend
        case "systematicgain.com":
        case "systematicgains.com":
        case "www.systematicgains.com":
        case "longshortd.trendrating.com":
        case "longonly.trendrating.com":
        case "longshort.trendrating.com":
        case "portfolios.trendrating.com":
        case "develop.portfolios.trendrating.com":
        case "app.systematicgains.com":
          return "https://www.trendrating-service.net";
      }
    }, []);

    return <Component {...props} domain={domain} />;
  };
};

export const HistoricalPortfolio = withIframeDomain(HistoricalPortfolioIFrame);

function HistoricalPortfolioIFrame({
  authToken,
  productId,
  type,
  domain,
  userType,
}: HistoricalPortfolioProps & IframeHOCProps) {
  const url = `${domain}/historical?id=${authToken}&productId=${productId}&type=${type}&userType=${userType}`;

  return (
    <div style={{ height: "85vh", width: "100%" }}>
      <iframe
        title={"Historical Portfolio"}
        src={url}
        width={"100%"}
        height={"98%"}
      />
    </div>
  );
}
